<template>
  <b-container>
    <b-row class="col-sm-12 col-md-12 col-lg-8 story ">
      <div class="numbers ">
        <blockquote>
          <p>
            Im OZG definierte Leistungen: <span>{{ count.services }}</span>
          </p>
        </blockquote>
        <blockquote>
          <p>
            Im OZG definierte Leistungen, die heute laut OZG-Portal teilweise
            irgendwo gesetzeskonform umgesetzt sind:
            <span>{{ count.services_implemented }}</span>
          </p>
        </blockquote>
      </div>
      <div class="numbers">
        <blockquote>
          <p>
            Im Leistungskatalog definierte Leistungen, die laut OZG umgesetzt
            werden müssen: <span>{{ count.features }}</span>
          </p>
        </blockquote>
        <blockquote>
          <p>
            Im Leistungskatalog definierte Leistungen, die heute irgendwo
            gesetzeskonform umgesetzt sind:
            <span>{{ count.features_implemented }}</span>
          </p>
        </blockquote>
        <blockquote>
          <p>
            Im Leistungskatalog definierte Leistungen, die angeblich online nicht sinnvoll umsetzbar sind:
            <span>{{ count.features_not_implementable }}</span>
          </p>
        </blockquote>
      </div>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "funFactNumbers",
  data() {
    return {
      count: {}
    };
  },
  watch: {
    countServicesAndFeatures: function(newVal) {
      var impl = {};

      for (var x in newVal) {
        // Shows only the explicitly set index of "5", and ignores 0-4
        impl[newVal[x].name] = newVal[x].count;
      }

      this.count = impl;
    }
  },
  apollo: {
    $client: "ozgClient",
    countServicesAndFeatures: {
      query() {
        return require("../../graphql/ozgServiceCount.gql");
      }
    }
  }
};
</script>

<style scoped></style>
